/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as TextLayerSpec } from '../../../../layer/preset/text/text';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';
import type { Data } from '../../specProcessor';

export type Spec = BaseSpec;

type TextLayerType = StandardChartLayerSpec & TextLayerSpec & ILayerTypeSpec;

// 创建文本图层数据类型验证器
const validateTextDataTypes = createDataTypeValidator('text', [
  { field: 'text', type: 'string' },
  { field: 'title', type: 'string' }
]);

// 创建文本图层编码验证器
const validateTextEncoding = createEncodingValidator([{ field: 'text' }, { field: 'title' }]);

// 额外的检查函数
const additionalTextChecks = (layer: TextLayerType, data: Data) => {
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];

  if (!values.length) {
    utils.logger.warn(
      'warning',
      `No data available for "${layer.type}" layer at dataIndex: ${dataIndex}`
    );
  }
};

// 创建并导出文本图层处理器
export const text = createLayerProcessor<TextLayerType>(
  'text',
  validateTextEncoding,
  validateTextDataTypes,
  additionalTextChecks
);
